/* eslint-disable complexity */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import RevampCard from "./revamp-card";
import DefaultCard from "./default-card";
const BuyWithConfidence = (props) => {
    const { desktopCarCard } = props;
    const isDesktopCarCardVariant = getAbExpirementVariant(desktopCarCard, EXPERIMENT_TYPE.VARIANT_B);
    return (
        isDesktopCarCardVariant ? <RevampCard {...props} /> : <DefaultCard {...props} />
    );
};

BuyWithConfidence.propTypes = {
    desktopCarCard: PropTypes.object
};

export default BuyWithConfidence;
